module.exports = __webpack_public_path__ + "img/9788991402065.b75fd579.jpg";